import React, { useCallback, useContext, useMemo, useState } from "react";
import AlertContext from "../../context/alert/AlertContext";
import { Box, Flex } from "reflexbox";
import Button from "../UI/Button";
import { Body } from "../UI/Text";
import styled, { useTheme } from "styled-components";
import Card from "../UI/Card";
import PriceDisplay from "../Quote/PriceDisplay";
import { useLocation } from "react-router-dom";
import ConfiguratorContext from "../../context/configurator/ConfiguratorContext";
import { Formik, Form } from "formik";
import { Input } from "../UI/forms";

const ImgContainer = styled(Box)`
  max-height: 170px;
  width: 100%;
  overflow: hidden;
  flex: 4;
  text-align: center;
  img {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;
  }
`;

const QuantityWrapper = styled(Input)`
  text-align: center;
`;

const ProductCard = ({ product, inline, onProductClick }) => {
  const [quantity, setQuantity] = useState(1);
  const theme = useTheme();
  const { showFailureAlert } = useContext(AlertContext);

  const location = useLocation();
  const { 1: priceMode } = location.pathname.split("/");
  const { quote } = useContext(ConfiguratorContext);
  const isPlane = useMemo(() => quote?.isPlane, [quote]);
  const isDealer = useMemo(
    () => priceMode === "DealerQuote" || !isPlane,
    [priceMode, isPlane]
  );

  const onSetQuantity = useCallback(
    (positive) => {
      
      if (positive === true) {
        setQuantity(quantity + 1);
        return;
      }
      if (quantity === 1)
        return showFailureAlert("Cannot set Quantity lower than 1.");
      setQuantity(quantity - 1);
    },
    [quantity, showFailureAlert]
  );

  const {
    ID: id,
    img,
    Description: subtitle,
    Name: title,
    isQuickConfig,
    defaultPrice,
    quantityInStock,
    base64Image,
    discountPercentage,
    ImageUrl,
    ProductNumber,
    isNonConfigurable,
    PortalPricingEnabled
  } = product || {};
  const image = img || base64Image || ImageUrl;  
  
  if (inline)
    return (
      <Card
        onClick={() => onProductClick(id)}
        p="0.5rem !important"
        interactive
        key={id}
        width="16.6666%"
      >
        {!!image && (
          <img style={{ maxHeight: "unset" }} src={image} alt={title} />
        )}
      </Card>
    );
  return (    
    <Card
      key={id}
      width={[
        "calc(100% - 2rem)",
        "calc(100% - 2rem)",
        "calc(50% - 2rem)",
        "calc(33.3333% - 2rem)",
        "calc(25% - 2rem)",
        "calc(20% - 2rem)",
        "calc(20% - 2rem)",
      ]}
      minWidth="calc(20% - 2rem)"
      m="1rem"
    >
      {!!image && (
        <ImgContainer>
          <img src={image} alt={title} />
        </ImgContainer>
      )}
      <Flex
        flex={3}
        width={1}
        alignItems="center"
        flexDirection="column"
        my="1rem"
      >
        <Body bold center>
          {title}
        </Body>
        <Body center>{subtitle}</Body>
        {defaultPrice && !isQuickConfig ? (
          <>
            <Flex
              mt="1rem"
              justifyContent="space-between"
              alignItems="center"
              width={1}
            >
              <Body center>
                 {PortalPricingEnabled ? (
                  <PriceDisplay
                  isDealer={isDealer}
                  isPlane={isPlane}
                  isUnit
                  row={{
                    id,
                    defaultPrice,
                    price: defaultPrice || 0,
                    discountPercentage,
                    quantity,
                    ProductNumber,
                  }}
                />
          ) : null}
                
              </Body>
            </Flex>
            <Body center>
              <span style={{ fontWeight: "bold", marginRight: "0.65rem" }}>
                # In Stock:{" "}
              </span>{" "}
              {quantityInStock}
            </Body>
            {PortalPricingEnabled ? (
                 <Flex mt="0.5rem" alignItems="center">
                 <Button
                   reverse
                   onClick={() => onSetQuantity(false)}
                   color={theme.secondary}
                   size="tiny"
                   iconName="faMinus"
                 />
                 {/* <Body width="auto">{quantity}</Body> */}
                 <Formik                     
                enableReinitialize
                initialValues={{
                  quantity: quantity                                              
                }}
                validateOnMount={false}
                validateOnChange={false}                
              >
              {({ values }) => {                        
                  return (
                    <Form style={{width: "45%", display:"inherit", textAlign:"right", minWidth:"50px" }}  >                           
                        <QuantityWrapper 
                        type="text"                                                        
                        onBlur={(e) => {
                          if (isNaN(e.target.value)) return;

                          if (Number(e.target.value) <= 0) {                                                                                                                   
                                                
                            showFailureAlert(
                              "Quantity must be greater than zero."
                            );   
                            return;                                                                                                             
                          } 
                          
                          setQuantity(Number(e.target.value));
                         
                        }}
                        name="quantity"
                        value={values.quantity}                                                                                     
                      />                      
                    </Form>
                  );
              }
            }
            </Formik>
                 <Button
                   reverse
                   onClick={() => onSetQuantity(true)}
                   color={theme.secondary}
                   size="tiny"
                   iconName="faPlus"
                 />
               </Flex>
          ) : null}
            
          </>
        ) : null}
      </Flex>

      {PortalPricingEnabled ? (
                <Flex flex={0}>
                <Button
                  color={isNonConfigurable ? theme.secondary : theme.primary}
                  onClick={() => onProductClick(id, quantity)}
                  iconName={!isNonConfigurable ? "faPenRuler" : "faPlus"}
                >
        
                  {!isNonConfigurable ? "Configure" : "Add To Quote"}
                </Button>
              </Flex> 
          ) : null}
      
    </Card>
  );
};

export default ProductCard;
